import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';

import { State, WallpaperRaw } from '../types';
import { ChannelsAPI } from '@wetransfer/transfer/api/channels';
import { objectKeysToCamelCase } from '@wetransfer/transfer/core-bundle/helpers/object-keys-camel-case';
import ErrorHandler from '@wetransfer/transfer/modules/error-handler';
import Logger from '@wetransfer/transfer/modules/logger';

export enum ACTION_TYPES {
  SET_WALLPAPERS = 'SET_WALLPAPERS',
}

export function fetchWallpapers({
  name,
}: {
  name: string;
}): ThunkAction<void, State, null, Action> {
  return async (dispatch) => {
    try {
      const { body: wallpapers } = (await ChannelsAPI.fetchWallpapers(null, {
        pathExtValues: { name },
      })) as {
        body: WallpaperRaw[];
      };

      dispatch({
        type: ACTION_TYPES.SET_WALLPAPERS,
        wallpapers: objectKeysToCamelCase(wallpapers),
      });
    } catch (error) {
      Logger.error(error);
      ErrorHandler.track(error);
    }
  };
}
